import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialogRef } from '@angular/material/dialog';
import { UsuarioService } from '../../../services/usuario.service';


@Component({
    selector: 'app-cancelar-pedido',
    templateUrl: './cancelar-pedido-dialog.html',
    styleUrls: ['./cancelar-pedido-dialog.scss', '../../../styles/estilo.padrao.scss']
})

export class CancelarPedidoDialog implements OnInit {
    bAutenticado: boolean = false;
    senhaMaster: string;

    uid;
    cancelamentoForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private spinner: NgxSpinnerService,
        private dialogRef: MatDialogRef<CancelarPedidoDialog>,
        private usuarioService: UsuarioService,
    ) {
        this.uid = localStorage.getItem('uid')
    }

    ngOnInit(): void {
        this.cancelamentoForm = this.formBuilder.group({
            motivo: ['', [Validators.required]],
        });
    }

    confirmarCancelamento() {
        if (this.cancelamentoForm.valid) {
            this.dialogRef.close(this.cancelamentoForm.get('motivo').value);

        } else {
            this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
            this.cancelamentoForm.markAllAsTouched();
        }
    }

    cancelar() {
        this.dialogRef.close();
    }

    // convenience getter for easy access to form fields
    get f() { return this.cancelamentoForm.controls; }

    autenticarSenha() {
        this.spinner.show('default');

        this.toastr.warning('Realizando autenticação', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

        this.usuarioService.validarSenhaMaster(this.senhaMaster).then(resp => {
            this.toastr.clear();
            if (resp) {
                this.bAutenticado = true;
            } else {
                this.bAutenticado = false;
                this.toastr.error('A senha informada não confere!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
                this.senhaMaster = '';
                document.getElementById('input_senha_master').focus();
            }
            setTimeout(() => this.spinner.hide('default'), 150);
        }).catch(err => {
            this.toastr.clear();
            this.toastr.error('Houve um erro ao validar sua permissão! Tente novamente!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
            setTimeout(() => this.spinner.hide('default'), 300);

        })
    }

}
